import React from "react";
import "./MovieDetails.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import Navbar from "../components/Navbar/Navbar";

function MovieDetails() {
  const [movie, setMovie] = React.useState({});
  const [movieImages, setMovieImages] = React.useState([]);
  const params = useParams();

  const getMovie = async () => {
    const response = await axios({
      method: "GET",
      url: `https://api.themoviedb.org/3/movie/${params.id}?api_key=${process.env.REACT_APP_API_KEY}`,
      params: {
        include_adult: false,
      },
    });

    setMovie(response.data);
  };

  const getMovieImages = async () => {
    const response = await axios({
      method: "GET",
      url: `https://api.themoviedb.org/3/movie/${params.id}/images?api_key=${process.env.REACT_APP_API_KEY}`,
      params: {
        include_adult: false,
      },
    });

    setMovieImages(response.data.backdrops);
  };

  React.useEffect(() => {
    getMovie().catch(alert);
    getMovieImages().catch(alert);
  }, []);

  return (
    <>
      <Navbar />
      {movie.poster_path === null ? (
        <div className="container text-start mt-5">
          <h3>{movie.title}</h3>
          <hr />
          <div className="row">
            <div className="col-6">
              <p>Overview</p>
              <p className="about-text">{movie.overview}</p>
            </div>
            <div className="col-6">
              <p>Release date</p>
              <p className="about-text">{movie.release_date}</p>

              <p>Rating</p>
              <p className="about-text">{`${movie.vote_average}/10`}</p>
            </div>
          </div>
          <hr />
        </div>
      ) : (
        <>
          <Carousel indicators={false}>
            <Carousel.Item key={movie.backdrop_path}>
              <img
                className="d-block w-100 "
                src={`https://image.tmdb.org/t/p/w1280${movie.backdrop_path}`}
                alt={movie.title}
              />
            </Carousel.Item>

            {movieImages.map((movieImage) => (
              <Carousel.Item key={movieImage.file_path}>
                <img
                  className="d-block w-100"
                  src={`https://image.tmdb.org/t/p/w1280${movieImage.file_path}`}
                  alt={movie.title}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div className="container text-start mt-5">
            <h3>{movie.title}</h3>
            <hr />
            <div className="row">
              <div className="col-6">
                <p>Overview</p>
                <p className="about-text">{movie.overview}</p>
              </div>
              <div className="col-6">
                <p>Release date</p>
                <p className="about-text">{movie.release_date}</p>

                <p>Rating</p>
                <p className="about-text">{`${movie.vote_average}/10`}</p>
              </div>
            </div>
          </div>
        </>
      )}

      {/* </div> */}
    </>
  );
}

export default MovieDetails;
